import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-668e28f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["name", "value", "disabled", "checked"]
const _hoisted_2 = {
  key: 0,
  class: "radio__signs"
}
const _hoisted_3 = { class: "radio__main-sign" }
const _hoisted_4 = { class: "radio__hint-sign" }

import { computed, useSlots, PropType } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmRadio',
  props: {
  /**
   * Значение
   */
  modelValue: { type: [Number, String, Object] as PropType<number | string | object | null>, default: null },
  /**
   * Название группы
   */
  name: { type: String, default: "" },
  /**
   * Значение которое принимает modelValue при выборе кнопки
   */
  value: { type: [Number, String, Object] as PropType<number | string | object | null>, default: null },
  /**
   * Дизейбл
   */
  isDisabled: { type: Boolean as PropType<boolean>, default: false },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;



const slots = useSlots();

/**
 * Есть ли слот для лейбла
 */
const isLeft = computed(() => slots && slots.mainSign && slots.mainSign());

/**
 * События
 */

/**
 * При изменении значения
 */
const onChange = (e: Event) => {
  if (props.isDisabled) return;
  let value = (e.target as HTMLInputElement)?.value;
  let formated = typeof value == 'string' ? value : JSON.parse(value);
  emit("update:modelValue", formated);
};

/**
 * Внутреннее значение
 */
const isCheck = computed(() => {
  return props.modelValue == props.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["radio", { 'radio--disabled': props.isDisabled }])
  }, [
    _createElementVNode("input", {
      type: "radio",
      onChange: onChange,
      name: props.name,
      value: props.value,
      disabled: props.isDisabled,
      checked: isCheck.value,
      tabindex: "0"
    }, null, 40, _hoisted_1),
    _createElementVNode("div", {
      class: _normalizeClass(["radio__box", { 'radio__box--check': isCheck.value }])
    }, null, 2),
    (isLeft.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _renderSlot(_ctx.$slots, "mainSign")
          ]),
          _createElementVNode("span", _hoisted_4, [
            _renderSlot(_ctx.$slots, "hintSign")
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})